
import { computed, ComputedRef, defineComponent, ref } from "vue";
import TextareaAutosize from "./textarea-autosize-styleless.vue";

export default defineComponent({
  name: "TNTextarea",
  components: {
    TextareaAutosize
  },
  props: {
    label: String,
    required: Boolean,
    description: String,
    error: String,
    warn: String,
    success: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    modelValue: String,
    textareaClass: String,
    minHeight: { type: Number, default: 68 },
    maxHeight: { type: Number, default: 248 }
  },
  emits: ["update:modelValue"],
  setup(props, { emit, slots }) {
    const textarea = ref(null);
    const inputId: ComputedRef<string> = computed(
        () => `tn-input-${Math.floor(Math.random() * 9999) + 1}`
      ),
      isTextareaDisabled: ComputedRef<boolean> = computed(
        () => props.readonly || props.disabled || false
      ),
      hasLabelSlot: ComputedRef<boolean> = computed(() => !!slots.label),
      hasDescriptionSlot: ComputedRef<boolean> = computed(
        () => !!slots.description
      );

    function emitInput(value: string) {
      emit("update:modelValue", value);
    }

    return {
      textarea,
      inputId,
      isTextareaDisabled,
      hasLabelSlot,
      hasDescriptionSlot,
      emitInput
    };
  }
});
